/**
 * External Dependencies
 */
import 'jquery';
import 'slick-carousel';
import AOS from 'aos';
import Vue from 'vue';
import CpStoreLocator from "./components/store-locator/CpStoreLocator.vue";
import CpStoreLocatorList from "./components/store-locator/CpStoreLocatorList.vue";
import CpStoreLocatorMap from "./components/store-locator/CpStoreLocatorMap.vue";
import CpStoreLocatorModal from "./components/store-locator/CpStoreLocatorModal.vue";
import CpStoreLocatorSearch from "./components/store-locator/CpStoreLocatorSearch.vue";
import ActionsDispatcher from "./plugins/ActionsDispatcher";
import EventsBus from "./plugins/EventsBus";

if (document.querySelector('.app') !== undefined) {
    const config = {
        el: '.app',
        components: {
            CpStoreLocator,
            CpStoreLocatorList,
            CpStoreLocatorMap,
            CpStoreLocatorModal,
            CpStoreLocatorSearch,
        },
        directives: {},
        mixins: [],
        options: {},
        ignoredElements: [],
    };

    Vue.use(EventsBus);
    Vue.use(ActionsDispatcher);

    new Vue(config);
}

$(document).ready(() => {
    // Get and set color attribute from the options page
    setTimeout(function () {
        AOS.init({
            // Global settings:
            disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
            startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
            initClassName: 'aos-init', // class applied after initialization
            animatedClassName: 'aos-animate', // class applied on animation
            useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
            disableMutationObserver: false, // disables automatic mutations' detections (advanced)
            debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
            throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

            // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
            offset: 240, // offset (in px) from the original trigger point
            delay: 0, // values from 0 to 3000, with step 50ms
            duration: 400, // values from 0 to 3000, with step 50ms
            easing: 'ease', // default easing for AOS animations
            once: true, // whether animation should happen only once - while scrolling down
            mirror: false, // whether elements should animate out while scrolling past them
            anchorPlacement: 'top-center', // defines which position of the element regarding to window should trigger the animation
        });
    }, 200);
    $(".css").each(function (e) {
        $("body").css({
            "--color-white": $(this).attr('data-color-white'),
            "--color-dark": $(this).attr('data-color-dark'),
            "--color-grey": $(this).attr('data-color-grey'),
            "--color-grey-light": $(this).attr('data-color-grey-light'),
            "--color-grey-dark": $(this).attr('data-color-grey-dark'),
            "--color-primary": $(this).attr('data-color-primary'),
            "--color-primary-light": $(this).attr('data-color-primary-light'),
            "--color-background-light": $(this).attr('data-color-background-light'),
        });
    });

    $('.pagination_actualites').on('click', 'a', function (e) {
        e.preventDefault();
        let href = $(this).attr('href');
        console.log(href);
        $.ajax(href)
            .done(function (data) {
                //get next article and push at the end
                let targetArticle = $(data).find('.actualite__container').html();
                $('.actualite__container').html('');
                $('.actualite__container').append(targetArticle);
            })
            .fail(function (jqxhr) {
                console.log(jqxhr.responseText);
            });
    });

    var prevScrollpos = window.pageYOffset;
    $('body').addClass('nav--show nav--top');
    window.onscroll = function () {
        var st = $(this).scrollTop();
        var currentScrollPos = window.pageYOffset;

        if (prevScrollpos > currentScrollPos || currentScrollPos == 0) {
            if (currentScrollPos < 700) {
                $('body').addClass('nav--show nav--top');
            } else {
            }
        } else {
            if (currentScrollPos > 500) {
                $('body').removeClass('nav--top');
            }
        }

        prevScrollpos = currentScrollPos;
    }

    $('.js-slider').slick({
        dots: true,
        infinite: true,
        prevArrow: '<svg class="prev" width="13" height="24" viewBox="0 0 13 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.4144 23.9999C10.1583 24.0008 9.90528 23.9442 9.67391 23.8345C9.44254 23.7247 9.2387 23.5645 9.07736 23.3657L0.798146 13.0809C0.546029 12.7742 0.408203 12.3895 0.408203 11.9924C0.408203 11.5954 0.546029 11.2107 0.798146 10.904L9.36877 0.619231C9.65972 0.269179 10.0778 0.0490432 10.5311 0.00725332C10.9843 -0.0345366 11.4356 0.105442 11.7857 0.396395C12.1357 0.687348 12.3559 1.10544 12.3977 1.5587C12.4394 2.01196 12.2995 2.46326 12.0085 2.81331L4.34638 12.001L11.7514 21.1887C11.961 21.4403 12.0942 21.7467 12.1351 22.0716C12.176 22.3965 12.123 22.7264 11.9824 23.0221C11.8417 23.3178 11.6193 23.5671 11.3414 23.7404C11.0635 23.9137 10.7418 24.0037 10.4144 23.9999Z" fill="#FF5B1A"/></svg>',
        nextArrow: '<svg class="next" width="13" height="24" viewBox="0 0 13 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.39812 0.000117381C2.6542 -0.000754255 2.90722 0.0557643 3.13859 0.165517C3.36997 0.275272 3.57381 0.435472 3.73514 0.634345L12.0144 10.9191C12.2665 11.2258 12.4043 11.6105 12.4043 12.0076C12.4043 12.4046 12.2665 12.7893 12.0144 13.096L3.44373 23.3808C3.15278 23.7308 2.73469 23.951 2.28143 23.9927C1.82817 24.0345 1.37687 23.8946 1.02682 23.6036C0.676766 23.3127 0.456632 22.8946 0.414842 22.4413C0.373052 21.988 0.51303 21.5367 0.803983 21.1867L8.46612 11.999L1.0611 2.81128C0.851496 2.55967 0.718348 2.25329 0.677415 1.92838C0.636482 1.60347 0.689478 1.27363 0.830132 0.977897C0.970786 0.682162 1.19321 0.43291 1.47109 0.259629C1.74897 0.0863466 2.07066 -0.00370879 2.39812 0.000117381Z" fill="#FF5B1A"/></svg>',

    });

    $('.files__tab').each(function (index) {
        if (index == 0) {
            $(this).addClass('actif');
        }
    });

    $('.files__tab__content').each(function (index) {
        if (index == 0) {
            $(this).addClass('actif');
        }
    });

    $('.files__tab').on('click', function (e) {
        e.preventDefault();
        let id = $(this).attr('data-tab');
        console.log(id);
        $('.files__tab').each(function () {
            $(this).removeClass('actif');
        });
        $(this).addClass('actif');
        $('.files__tab__content').each(function () {
            $(this).removeClass('actif');
            if ($(this).hasClass(id)) {
                $(this).addClass('actif');
            }
        });
    });

    // $('.toggle').on('click', function(e) {
    //   $(this).addClass('open');
    //   $('body').addClass('menu-big');
    //   if($(this).attr('data-test') != 'true' ) {
    //     e.preventDefault();
    //   }
    //   $(this).attr('data-test', true);

    // });


    // $('.menu-item-has-children').on('mouseover', function(e) {
    //   $('.menu-item-has-children').each(function( index ) {
    //     $(this).removeClass('open');
    //   });
    //   $(this).addClass('open');
    //   if(!$(this).hasClass('wpml-ls-current-language')) {
    //     $(this).addClass('open');
    //     $('body').addClass('menu-big');
    //   }
    // });


    $('.cross-menu').on('click', function (e) {
        $('.toggle').removeClass('open');
        $('.toggle').attr('data-test', false);
        $('body').removeClass('menu-big');
    });


    $('.nav__secondary .search').on('click', function (e) {
        e.preventDefault();
        $('body').toggleClass('search--open');
        $('.nav__search').toggleClass('d-none');
    });

    $('.burger svg').on('click', function (e) {
        e.preventDefault();
        $('.nav__search').toggleClass('d-none');
        if ($("body").hasClass("mobile--open")) {
            $('body').toggleClass('search--open');

        } else {
            $('body').addClass('mobile--open search--open');
        }
    });

    $('.burger__icon').on('click', function (e) {
        if ($("body").hasClass("mobile--open")) {
            $('body').removeClass('mobile--open search--open');
            $('.nav__search').addClass('d-none');
            $('body').removeClass('menu-big');
        } else {
            $('body').addClass('mobile--open');
        }
    });

    // $('.menu-item-has-children').on('click', function (e) {
    //   // if($(this).attr('data-test') != 'true' ) {
    //   //   if(!$(this).hasClass('wpml-ls-current-language')) {
    //   //     e.preventDefault();
    //   //   }
    //   // }
    //   $(this).toggleClass('open');
    //   // $(this).attr('data-test', true);
    // });

    // if (navigator.userAgent.indexOf("Firefox") > 0) {
    // }

    var is_mobile = false;

    if ($('#mobile').css('display') == 'none') {
        is_mobile = true;
    }


    /**
     * Handle navbar
     */
    if (is_mobile == true) {
        //Conditional script here
        console.log('mobile');
        $('.menu-item-has-children > a').on('click', function (e) {
            $(this).toggleClass('open');
            e.preventDefault();
            $(this).on('click', 'a', function (e) {
            });
        });
    } else {
        const $all = $('.nav__link > .menu-item-has-children');
        $all.each(function () {
            const $this = $(this);
            let timeout = null;

            $this.on('mouseenter', function () {
                if (timeout) {
                    clearTimeout(timeout);
                }

                $all.removeClass('open');
                $this.addClass('open');
            });

            $this.on('mouseleave', function () {
                if ($this.hasClass('open')) {
                    timeout = setTimeout(function () {
                        $this.removeClass('open');
                    }, 400);
                }
            });
        });

        $('.sub-menu .menu-item').on('mouseenter', function (e) {
            const $this = $(this);
            $this.toggleClass('hover');
            setTimeout(function () {
                $this.removeClass('hover');
            }, 400);
        });
    }

    // $('.acf-map').each(function () {
    //     if (window.Cookiebot === undefined || !window.Cookiebot.consent.marketing) {
    //         $(this).addClass('blocked');
    //     }
    // });

    $('a[href="#cookiebot-modal"]').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (window.Cookiebot !== undefined) {
            window.Cookiebot.show();
        } else {
            alert('Cookiebot is not available. Please try again later.');
        }
    });
});


